if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.querySelectorAll('[data-modal-nav]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-modal-nav="prev"]')) {
            this.showAdjacentMedia(-1);
          } else if (event.target.closest('[data-modal-nav="next"]')) {
            this.showAdjacentMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaElements() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMedia(direction) {
        const mediaElements = this.getMediaElements();
        if (mediaElements.length < 2) return;

        const currentIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        const nextIndex = (currentIndex + direction + mediaElements.length) % mediaElements.length;
        const nextMedia = mediaElements[nextIndex];

        mediaElements.forEach((element) => element.classList.remove('active'));
        nextMedia.classList.add('active');

        const nextMediaTemplate = nextMedia.querySelector('template');
        const nextMediaContent = nextMediaTemplate ? nextMediaTemplate.content : null;
        if (
          nextMedia.nodeName == 'DEFERRED-MEDIA' &&
          nextMediaContent &&
          nextMediaContent.querySelector('.js-youtube')
        ) {
          nextMedia.loadContent();
        }
      }
    }
  );
}
